export default {
  label: {
    switch_lang: 'Switch language to:',
    no_resources_found: 'No resources found'
  },
  navbar: {
    logOut: 'Log Out',
    login: 'Login',
    signup: 'Signup',
    documentation: 'Documentation',
    console: 'Console'
  },
  breadcrumb: {
    back: 'Back'
  },
  sidebar: {
    privacy_policy: 'Privacy Policy',
    information: 'What we do with your information',
    security: 'Security',
    disclosure: 'Disclosure',
    cookies: 'Cookies',
    google_analytics: 'Google Analytics and Marketing',
    changes_privacy: 'Changes to Privacy Policy',
    data_deletion: 'Data Deletion'
  },
  login: {
    title: 'Login',
    email: 'Email',
    password: 'Password',
    forgotpass: 'Forgot Password',
    dont_have_account: 'Don\'t have an account?',
    clickhere: 'Click here',
    signin: 'Login',
    verified: 'Account verified',
    verified_message: 'Congratulations! your Olsera Open Platform account has been verified.',
    not_verified: 'Account not verified',
    explore_now: 'Explore now'
  },
  login_olsera: {
    title: 'Login to Olsera Account',
    description: 'our profile has to be updated before you can create a new app',
    button_loggin_account: 'Login to Olsera Account',
    button_loggin: 'Login',
    login_success: 'Login Success'
  },
  forgot: {
    title: 'Forgot Password',
    email: 'Email',
    signin: 'Login',
    backtopage: 'Back to page?',
    description: 'Please enter the email address registered with Olsera. We will send instructions to recover your password.',
    send: 'Send',
    forgot_success: 'Success link send to email',
    forgot_failed: 'Link failed to send to email'
  },
  reset: {
    title: 'Reset Password',
    new_password: 'New Password',
    c_new_password: 'Confirm New Password',
    button_reset: 'Reset',
    reset_success: 'Password has been successfully updated'
  },
  register: {
    title: 'Register',
    name: 'Name',
    email: 'Email',
    password: 'Password',
    c_password: 'Confirm New Password',
    have_account: 'Already have an account?',
    clickhere: 'Click here',
    sginup: 'Signup',
    resend: 'Resend',
    description1: 'By registering you have agreed to the',
    description2: 'and have read and understand the',
    term_condition: 'Terms and Conditions',
    privacy_policy: 'Privacy Policy',
    message: 'Please check your email and click the verification link within 24 hours to complete your registration.',
    verification_email: 'Email Verification',
    verification_sent: 'Confirmation email has been sent to',
    no_verification_email: 'Didn\'t receive the verification email?'
  },
  verification: {
    verified: 'Success link verification send to email',
    no_verified: 'Link failed verification send to email'
  },
  landing_page: {
    helping_merchants: 'Helping Merchants',
    to_open: 'To Open',
    new_opportunities: 'New Opportunities',
    button_get_access: 'Get Access Now',
    about_olsera: 'About Olsera',
    about_detail: 'Olsera is a much easier Premium Cashier App, with a wider reach and faster business growth.',
    features: {
      title: 'Olsera Platform Key Features & Benefits',
      open_api: 'Open API',
      open_api_desc: 'Offers a wide range of APIs covering core ecommerce business functionality.',
      technical_support: 'Technical Support',
      technical_support_desc: 'Dedicated technical support to provide a great customer experience.',
      testing_account: 'Testing Account & Tools',
      testing_account_desc: 'Accelerating development process by testing account and tool.',
      service_market: 'Service Market',
      service_market_desc: 'Expand service coverage and increase business opportunities.'
    },
    join_open_api: 'Join the Olsera Open Platform',
    description: 'Serve millions of sellers and unlock unlimited opportunities'
  },
  privacy_policy: {
    title: 'Privacy Policy',
    description: 'Olsera collects e-mail addresses from people who send e-mails. We also collect information about what pages users access and information provided to us by users through surveys and site registration. The information may contain personal data about you including your address, telephone number, credit card number etc. Olsera protects credit card information according to security standards. We are not allowed to disclose personal information without your written permission. However, certain information that is collected from you and about you is used in the context of providing our services to you. The information we collect is not shared with, sold or rented to others, except in certain circumstances and where the use of the Service is deemed to have obtained valid consent to disclose the following:',
    privacy1: 'Olsera may share personal information in order to investigate, prevent, or take action related to illegal activity, suspected fraud, situations involving possible threats to a person\'s physical safety, violations of Olsera\'s terms of use, or as required by law.',
    privacy2: 'Olsera employs other companies to perform tasks on our behalf and may need to share your information with them in order to provide you with products and services.',
    privacy3: 'We will transfer information about you if Olsera is transferred to another company. In this case, Olsera will notify you by email or by placing a prominent notice on Olsera\'s website before any information that has been transferred about you becomes subject to a different privacy policy.'
  },
  information: {
    title: 'What we do with your information'
  },
  security: {
    title: 'Security',
    description: 'The security of your personal information is very important to us. When you enter sensitive information, such as a credit card number on our registration form, we encrypt the transmission of the information using secure socket layer technology (SSL), but nothing is 100% specific and how you use your information will matter. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee absolute security. If you have any questions about security on our website, you can email us at',
    email: '{account}{\'@\'}{domain}'
  },
  disclosure: {
    title: 'Disclosure',
    description1: 'Olsera may use third party service providers to provide certain services to you and we may share personal information with those service providers. We need companies that can share personal information to protect data in a manner consistent with this policy and to limit the use of such personal information to the performance of services for Olsera. Olsera may disclose personal information in special situations, such as to comply with a court order requiring us to do so or when your actions violate the Terms of Service.',
    description2: 'We do not sell or provide personal information to other companies to market their own products or services.'
  },
  cookies: {
    title: 'Cookies',
    description: 'Olsera may use third party service providers to provide certain services to you and we may share personal information with those service providers. We need companies that can share personal information to protect data in a manner consistent with this policy and to limit the use of such personal information to the performance of services for Olsera. Olsera may disclose personal information in special situations, such as to comply with a court order requiring us to do so or when your actions violate the Terms of Service. We do not sell or provide personal information to other companies to market their own products or services.'
  },
  google_analytics: {
    title: 'Google Analytics and Marketing',
    description: 'We use a service provided by Google called Google Analytics (GA). GA allows us to reach people who have previously visited our site, and show them relevant advertisements when they visit other sites on the Internet within the Google Display Network. Cookies may be used to track your session on our website, to serve customized advertisements from Google and other third party vendors. When you visit this site, you may see advertisements posted on the site by Google or other third parties. Through first-party and third-party cookies, these third parties may collect information about you when you visit this site and other sites. They may use this data to serve ads on this site and on the Internet based on your prior visits to this website and elsewhere on the Internet. We do not collect this information or control the content of the advertisements that you will see. You may be able to opt out of customized Google Display Network advertising by visiting Ads Preferences (http://www.google.com/ads/preferences/), and the Google Analytics Opt-out Browser Add-on (http://www.google .ca/ads/preferences/plugins/). Your use of this site without opting out means that you understand and consent to the collection of data to provide you with remarketing advertisements using GA and cookies from other third party vendors based on your prior visits to this website and elsewhere on the Internet.'
  },
  changes_privacy: {
    title: 'Changes to Privacy Policy',
    description: 'Kami berhak untuk mengubah pernyataan privasi ini setiap saat, sehingga Anda disarankan untuk selalu meninjau ulang perubahan sesering mungkin. Jika kami membuat perubahan penting terhadap kebijakan ini, kami akan memberitahu Anda di sini atau dengan cara pemberitahuan di homepage kami sehingga Anda mengetahui informasi apa yang kami kumpulkan dan bagaimana kami menggunakannya.'
  },
  data_deletion: {
    title: 'Data Deletion',
    description: 'Customers can submit requests for deletion of data on the server by email to',
    email: '{account}{\'@\'}{domain}'
  },
  introduction_page: {
    intro_title: 'Introduction',
    production: '(Production)',
    language: 'Language',
    example: 'Example',
    api_url: 'https://api-open.all.olsera.indociti.com',
    console_app: 'console -> app list',
    intro_desc1: 'Olsera provides API that can be used to integrate your system with our platform.',
    intro_desc2: 'The API is built based on REST concept, and will return JSON formatted data upon your requests.',
    intro_desc3: 'The Olsera Open Platform can provide the following functionalities four our partners:',
    global_list: 'Global List',
    customer_list: 'Customer & Supplier List',
    product_list: 'Product List',
    order_management: 'Order management',
    purchase: 'Purchase',
    intro_desc4_a: 'To access our api, the client must register his olsera account in',
    intro_desc4_b: 'later the system will generate app_id and secret_key.',
    intro_desc5: 'app_id is used as a unique identifier for your account and is used to obtain an access_token, access_token is used to access the olsera api enpoint, while the secret key is used to encrypt data when requesting access_token',
    intro_desc6: 'Getting access_token and refresh token by api as follows:',
    intro_desc7: 'You need to encrypt data using hash_hmac(\'sha256\', $data, secret_key) $data is based on (app_id:timestamp) as follows:',
    intro_desc8_list1_a: 'Make a POST request to',
    intro_desc8_list1_b: 'here\'s an example:',
    intro_desc8_list2: 'If successful, you will receive an access_token and a refresh_token. When the access token expires, you must request a new token using refresh_token, the response example is:',
    intro_desc9: 'We also provide language in API with Indonesian/English options which can be implemented, You can change the language by adding path localization => [en / id] to all endpoints',
    quick_start_title: 'Quick Start',
    quick_start_desc1: 'You can try all API that we provided easily with Postman. Download a pre-built collection based on the Olsera Open API.',
    quick_start_desc2: 'For further explanation on how to use this collection in Postman, please jump to Testing Chapter.',
    api_reference: 'reference here'
  },
  store_list: {
    title: 'Store List',
    btn_create: 'Create',
    submit_success: 'Submit Success'
  },
  app_list: {
    title: 'App List',
    btn_create: 'Create App'
  },
  developer_guide: {
    overall_procedure: 'Overall Procedure',
    step1: {
      title: 'Step 1: Register the Olsera Platform',
      step1_a: 'a. Sign up for the Olsera Platform, send us your email and password',
      step1_b: 'b. A verification email has been sent to your email',
      step1_c: 'c. Click "Verify Your Email"',
      step1_d: 'd. Account has been verified',
      step1_e: 'e. You will also get an email account created successfully, click "Get Started"',
      step1_f: 'f. Login using a verified email and password',
      step1_g: 'g. If sometimes you forget your password, go to the "Forgot Password" page and send a registered email',
      step1_h: 'h. Click "Reset Password"',
      step1_i: 'i. Enter a new password and confirm your new password then click "Reset"'
    },
    step2: {
      title: 'Step 2: Create App',
      step2_a: 'a. Click "Login to Olsera Account" and will be directed to the next page',
      step2_b: 'b. Send your email address and password to login',
      step2_c: 'c. Login is successful, you will be redirected to the shop list page',
      step2_d: 'd. Select a store, and click "Next" to create your store application',
      step2_e: 'e. Enter the required data, then click "Create Application"',
      step2_f: 'f. Application created successfully, Click one to view details',
      step2_g: 'g. In the detail section, "App ID" and "Secret_key" are displayed along with other information',
      step2_h: 'h. In the "App Lock" section Click "Get Token" to get the access token, then click "Copy"',
      step2_i: 'i. Back to the "Documentation" menu then select a collection and click "Api Test Tool"',
      step2_j: 'j. In the "Request Parameters" section, enter the required data, then in the "Headers" section, enter the "Token" obtained earlier, then click "Send Request" to view the results.',
      step2_k: 'k. Click "Edit App" to change app information',
      step2_l: 'l. Click "Delete App" to delete the app'
    }
  },
  app_create: {
    btn_create: 'Create App'
  },
  app_detail: {
    basic_information: 'Basic Information',
    app_key: 'App Key',
    get_token: 'Get Token',
    copy: 'Copy'
  },
  app_edit: {
    select_file: 'Select File',
    choose_file_type: 'Choose a file or drop it here to upload',
    change_logo: 'Change Logo',
    delete_confirm_app: 'Are you sure you want to delete Application?',
    delete_confirm_logo: 'Are you sure you want to delete this image?',
    cancel_confirm: 'Cancel',
    accept_confirm: 'Ya',
    delete: 'Delete',
    btn_delete_app: 'Delete App',
    btn_cancel: 'Cancel',
    btn_save: 'Save',
    verified_callback_url: 'Verified, please save the call back URL and go to push setting for advanced use.',
    not_verified_callback_url: 'Not verified, the call back URL not found.',
    app_updated: 'App detail has been updated!',
    app_deleted: 'App has been deleted!'
  },
  api_tool: {
    title: 'Alat Test API',
    send_request: 'Send Request'
  },
  warning: {
    complete_the_data: 'Please complete the data'
  },
  webhook: {
    wb_setting: 'Webhook setting',
    wb_edit: 'Webhook edit',
    wb_log: 'Request log',
    wb_open: 'Open setting',
    wb_add_more: 'Add more header',
    wb_save: 'Save',
    wb_close: 'Close',
    cb_not_set: 'URL Callback is not set',
    cb_success: 'Callback URL successfully saved',
    cb_failed: 'Callback URL failed saved',
    save_success: 'Berhasil disimpan',
    save_failed: 'Gagal disimpan',
    message_success: 'Callback URL success to save.',
    message_failed: 'Callback URL failed to save because an error occurred.',
    no_data: 'No data'
  }
}
